export const carouselItems = [
  {
    image:
      "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Integration+hero+image.svg",
    subtitle: "Integration",
    description:
      "Ready to use connectors with 1000+ enterprise applications",
  },
  {
    image:
      "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/AI+Workflow+hero+image.svg",
    subtitle: "AI Workflow",
    description:
      "Design complex, AI workflows just by describing it",
  },
  {
    image:
      "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Agentic+interaction+hero+image.svg",
    subtitle: "Agentic Interaction",
    description:
      "Build diverse AI interfaces over Chat, AI apps or embed UIs into your application",
  },
  {
    image:
      "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/UX+abstraction+hero+image.svg",
    subtitle: "UI/UX Abstraction",
    description:
      "Intuitive AI-powered interfaces with drag-and-drop simplicity",
  },
];

export const testimonials = [
  {
    quote: `${"Cobalt slashed our dev time 6x and cut TCO by 53%. What once took months now takes hours—letting us focus on exceptional customer experiences."}`,
    author: {
      name: "Prayas Tiwari",
      title: "Senior Product Manager",
      image: "/images/testimonials/emily-watson.jpg"
    },
    backgroundImage: "/about-us/ovation-cobalt.jpg",
    logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+Page-+icons/Ovation+logo+updated.svg",
    actionUrl: "https://gocobalt.io/case-studies/how-ovationcxm-transformed-integration-efficiency-with-cobalt"
  },
  {
    quote: `${"Cobalt doubled our customer acquisition, unlocked high-value deals, and slashed integration costs by 50%—all with lightning-fast implementation"}`,
    author: {
      name: "Malav Joshi",
      title: "Product Manager",
      image: "/images/testimonials/michael-rodriguez.jpg"
    },
    backgroundImage: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/Testimonial+2.jpg",
    logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+Page-+icons/aleshandy+updated+logo.svg",
    actionUrl: "https://gocobalt.io/case-studies/saleshandy/"
  },
  {
    quote: `${"Cobalt cut our development time by 70% and helped us launch powerful writeback and scheduling features in weeks. Now, our teams move faster, and our customers get insights in minutes."}`,
    author: {
      name: "Anurag Malik",
      title: "VP Product Management",
      image: "/images/testimonials/emily-watson.jpg"
    },
    backgroundImage: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/Testimonial+3.jpg",
    logo: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/incorta/logo.png",
    actionUrl: "https://gocobalt.io/case-studies/how-incorta-transformed-writeback-development-with-cobalts-scalable-platform/"
  },
];

export const infrastructureFeatures = [
  {
    title: "Workflow automation at your fingertips",
    description: "Forget cumbersome setups and lengthy deployments. Our visually-enhanced Workflow Builder enables drag and drop designing to connect applications, automate tasks.",
    imageSrc: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Workflow+automation+at+your+fingertips.svg",
    imageAlt: "Workflow automation interface showing a workflow diagram"
  },
  {
    title: "Unmatched native experience",
    description: "Avoid typical scaling hassles and ensure high performance with us.",
    imageSrc: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Unmatched+native+experience.svg",
    imageAlt: "Native integration experience with JIRA"
  },
  {
    title: "Limitless scalability",
    description: "Avoid typical scaling hassles and ensure high performance with our load balancing and auto-scaling capabilities using Kubernetes. Plus, ensure reliability and continuity in unlikely events with our sturdy failover systems.",
    imageSrc: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Limitless+scalability.svg",
    imageAlt: "Scalability interface showing integration dashboard"
  },
  {
    title: "Robust API management",
    description: "Run integrations smoothly without manual oversight. Cobalt's intelligent throttling, built-in retry logics, and advanced queuing manages rate limits and avoids disruptions during peak periods.",
    imageSrc: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Robust+API+management.svg",
    imageAlt: "API management interface with code and connections"
  },
  {
    title: "Managed authentication",
    description: "Automated identity management including granular access control.",
    imageSrc: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Managed+authentication.svg",
    imageAlt: "Authentication interface for Netsuite with encryption options"
  },
  {
    title: "Observability & error handling",
    description: "Optimize operations of all integration through centralized usage tracking.",
    imageSrc: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Unmatched+native+experience.svg",
    imageAlt: "JIRA integration showing error handling logs"
  }
];

export const bentoItemsData = [
  {
    id: 'app-marketplace',
    title: 'App Marketplace',
    description: 'Launch a white-labeled integration hub and make it easy for customers to discover integrations.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+Page-+icons/App+marketplace.svg',
  },
  {
    id: 'data-migration',
    title: 'Data Migration',
    description: 'Don\'t wrestle with tangled code endless scripts to transfer data. Just map, connect, move.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+Page-+icons/Data+migration.svg',
  },
  {
    id: 'internal-workflow',
    title: 'Internal Workflow Conductor',
    description: 'Orchestrate and deploy complex workflows across applications, microservices, AI features.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+Page-+icons/Internal+workflow+conductor.svg',
  },
  {
    id: 'enterprise-connectors',
    title: 'Enterprise Connectors',
    description: 'Expand your market reach by connecting with hard-to-link systems like Workday and SAP.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+Page-+icons/Enterprise+connector.svg',
  },
  {
    id: 'ai-readiness',
    title: 'AI-Readiness',
    description: 'Stream clean, structured LLM-ready data from every corner of your product ecosystem.',
    iconPath: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+Page-+icons/AI+readyness.svg',
  }
];

export const integrationApps = [
  // First row - 15 apps
  { id: '1', name: 'Salesforce', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/salesforce/logo.png' },
  { id: '2', name: 'SAP', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/sap_s4_hana/logo.png' },
  { id: '3', name: 'Oracle Financials', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/oracle_financials/logo.png' },
  { id: '5', name: 'ServiceNow', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/servicenow/logo.png' },
  { id: '6', name: 'Jira', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/jira/logo.png' },
  { id: '7', name: 'Workday', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/workday/logo.png' },
  { id: '8', name: 'Netsuite', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/netsuite/logo.png' },
  { id: '9', name: 'Quickbooks', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/quickbooks/logo.png' },
  { id: '10', name: 'Zendesk', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/zendesk/logo.png' },
  { id: '11', name: 'Lever', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/lever/logo.png' },
  { id: '12', name: 'Snowflake', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/snowflake/logo.png' },
  { id: '13', name: 'Outreach', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/outreach/logo.png' },
  { id: '14', name: 'Okta', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/okta/logo.png' },
  { id: '15', name: 'Marketo', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/marketo/logo.png' },
  // Second row - 15 apps
  { id: '16', name: 'Google Admin', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/google_admin/logo.png' },
  { id: '17', name: 'Slack', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/slack/logo.png' },
  { id: '18', name: 'BambooHR', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/bamboohr/logo.png' },
  { id: '19', name: 'Amazon S3', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/amazons3/logo.png' },
  { id: '20', name: 'ActiveCampaign', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/activecampaign/logo.png' },
  { id: '21', name: 'Zoho CRM', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/zohocrm/logo.png' },
  { id: '22', name: 'Aircall', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/aircall/logo.png' },
  { id: '23', name: 'Asana', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/asana/logo.png' },
  { id: '24', name: 'Notion', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/notion/logo.png' },
  { id: '25', name: 'Box', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/box/logo.png' },
  { id: '26', name: 'Deel', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/deel/logo.png' },
  { id: '27', name: 'Amplitude', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/amplitude/logo.png' },
  { id: '28', name: 'Dropbox', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/dropbox/logo.png' },
  { id: '29', name: 'High Level', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/highlevel/logo.png' },
  { id: '30', name: 'PostgreSQL', icon: 'https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/postgresql/logo.png' },
];

export const bentoItems = [
  {
    title: "Go-to-market sooner",
    description:
      "Planning, developing and releasing integrations should not take months, with us you go live in days",
    imageSrc:
      "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Go+to+market.jpg",
    imageAlt: "Go to market illustration",
  },
  {
    title: "Reduce engineering backlogs",
    description:
      "Save countless hours of developer work and distracting them from your core product roadmap",
    imageSrc:
      "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Reduce+engineering+backlog.jpg",
    imageAlt: "Engineering illustration",
  },
  {
    title: "Expand Market Reach",
    description:
      "Increase your integration offerings and product coverage without additional engineering resources",
    imageSrc:
      "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Expand+market+research.jpg",
    imageAlt: "Market reach illustration",
  },
];

export const trustLogos = [
  { src: "/clients/incorta.svg", alt: "Incorta" },
  { src: "/clients/ovationcxm.svg", alt: "OvationCXM" },
  { src: "/clients/saleshandy.svg", alt: "Saleshandy" },
  { src: "/clients/velocityglobal.svg", alt: "Velocity Global" },
  { src: "/clients/omni.svg", alt: "Omni" },
  { src: "/clients/rocketium.svg", alt: "Rocketium" },
  { src: "/clients/imagekit.svg", alt: "Imagekit" },
  { src: "/clients/recotap.svg", alt: "Recotap" },
  { src: "/clients/airmeet.svg", alt: "Airmeet" },
  { src: "/clients/recruiterflow.svg", alt: "Recruiterflow" },
];

export const recognitionBadges = {
  excellence: [
    {
      src: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/G2+leader.jpg",
      alt: "G2 Leader Winter 2025",
    },
    {
      src: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/G2+momentum+leader.jpg",
      alt: "G2 Momentum Leader Fall 2024",
    },
    {
      src: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/G2+Most+implemented.jpg",
      alt: "G2 Most Implementable Winter 2025",
    },
    {
      src: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/About+us/G2+Best+Est.+ROI.jpg",
      alt: "G2 Best ROI Winter 2025",
    },
  ],
  security: [
    {
      src: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+Page-+icons/AICPA.png",
      alt: "SOC 2 Type II Certified",
    },
    {
      src: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+Page-+icons/ISO.png",
      alt: "ISO 27001 Certified",
    },
    {
      src: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+Page-+icons/GDPR.png",
      alt: "GDPR Compliant",
    },
    {
      src: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+Page-+icons/VAPT.png",
      alt: "HIPAA Compliant",
    },
  ]
};

export const homeData = {
  hero: {
    tag: {
      text: "Cobalt MCP",
      href: "/cobalt-mcp",
    },
    title: "Redefining how Softwares & Agents interact with Enterprise Apps",
    description: "Cobalt helps product and engineering teams <strong>build</strong> native integrations, <strong>deploy</strong> them within days, and <strong>monetize</strong> them — with the help of AI agents",
    cta: {
      primary: {
        text: "Get Started",
        href: "/sign-up",
      },
      secondary: {
        text: "Book a demo",
        href: "https://cal.com/cobalt/welcome-to-cobalt",
      },
    },
  },
  bento: {
    title: "We disrupted the sub-optimal integration experience and made it flexible, real-time & embeddable",
    description: "Say goodbye to authentication hassles, data mapping puzzles and infrastructure maintenance nightmares"
  },
  infrastructure: {
    tag: "INFRASTRUCTURE",
    title: "A plug-and-play architecture engineered for end-users",
    description: "Build connected systems with native usability, concurrent and scalable performance, and robust security"
  },
  useCases: {
    tag: "USE CASES",
    title: "Stay ahead with reliable solutions to modern integration challenges",
    description: "Cobalt enables context-aware use cases for engineering and product teams so that they are always in-sync and ahead of the curve",
    demoSection: {
      title: "Experience the ease and scale of Cobalt",
      imageSrc: "https://cobalt-app-logos.s3.ap-south-1.amazonaws.com/website_images/Home+page-+Images/Slack-integration-screenshot.png",
      imageAlt: "Cobalt Platform Demo",
      ctaText: "Learn more",
      ctaHref: "#learn-more"
    }
  },
  hsIntegrations: {
    tag: "INTEGRATIONS",
    title: "1,000+ pre-built connectors to deliver native experiences",
    subtitle: "Instantly connect popular apps with our growing library of pre-built connectors",
    buttonText: "Browse Integrations"
  },
  testimonialCarousel: {
    backgroundColor: "bg-black",
    textColor: "text-white",
    showActionButton: true,
    actionButton: {
      text: "VIEW SUCCESS STORY"
    },
    impactSection: {
      tag: "IMPACTS",
      title: "We're helping teams to focus on what they do best — build products"
    }
  },
  recognition: {
    excellence: {
      tag: "REVIEWS",
      title: "Recognized Excellence in Embedded iPaaS",
      description: "Powering next-generation startups and established companies"
    },
    security: {
      tag: "Enterprise Ready",
      title: "Build to meet strong security & compliance standards",
      description: "Enterprise-grade security with SOC 2 Type II compliance and robust data protection measures",
      learnMoreHref: "https://security.gocobalt.io/"
    }
  },
  trust: {
    title: "Best-in-class firms are our customers"
  },
  cloudTabDisplay: {
    tag: "DEPLOYMENT OPTIONS",
    title: "Flexible Deployment Models for Every Business Need",
    description: "Choose the right deployment model that suits your business requirements and infrastructure preferences"
  },
  cta: {
    title: "The future of software is seamlessly Integrated",
    description: "Be ready with Cobalt's embedded integration platform",
    cta: {
      text: "Get Started",
      href: "/sign-up",
      secondary: {
        text: "Book a Demo",
        href: "https://cal.com/cobalt/welcome-to-cobalt"
      }
    }
  }
};